import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import cn from 'classnames'
import styles from './style.module.css'
import PageHeader from '~components/PageLayout/PageHeader'
import PageLayout from '~components/PageLayout'
import ChartPreloader from '~pages/AssetPage/Preloader/ChartPreloader'
import HistoryRowSkeleton from '~pages/AssetPage/Preloader/skeletons/HistoryRowSkeleton'
import MultiWidgetPreloader from '~components/MultiWidget/Preloader'

function Preloader() {
    const action = (
        <div className={styles.action}>
            <Loader />
            <Loader />
        </div>
    )

    return (
        <PageLayout
            contentWidth="xl"
            header={
                <PageHeader
                    rootPage={false}
                    title={
                        <div className={styles.title}>
                            <Loader />
                        </div>
                    }
                    right={<Loader width={24} height={24} />}
                />
            }
        >
            <div className={styles.wrap}>
                <div className={styles.main}>
                    <div className={styles.assetHeader}>
                        <div className={styles.assetIcon}>
                            <Loader width={48} height={48} />
                        </div>

                        <div className={styles.assetHeaderLeft}>
                            <Loader />
                            <Loader />
                        </div>
                        <div className={styles.assetHeaderRight}>
                            <Loader />
                            <Loader />
                        </div>
                    </div>

                    <div className={styles.chart}>
                        <ChartPreloader />
                    </div>

                    <div className={styles.periods}>
                        <Loader />
                        <Loader />
                        <Loader />
                        <Loader />
                        <Loader />
                        <Loader />
                    </div>

                    <div className={styles.divider} />

                    <div className={styles.balanceWrap}>
                        <Loader />
                        <Loader />
                    </div>

                    <div className={styles.actionsWrap}>
                        {action}
                        {action}
                        {action}
                        {action}
                    </div>

                    <div className={styles.historyWrap}>
                        <div className={styles.historyTitle}>
                            <Loader />
                            <Loader />
                        </div>

                        <HistoryRowSkeleton />
                        <HistoryRowSkeleton />
                        <HistoryRowSkeleton />
                    </div>
                </div>
                <div className={cn(styles.dividerColumn, styles.hideOnMobile)} />
                <div className={cn(styles.rightColumn, styles.hideOnMobile)}>
                    <MultiWidgetPreloader />
                </div>
            </div>
        </PageLayout>
    )
}

export default Preloader
